var map = {
	"./ada_black_idling.png": 24909,
	"./ada_blue_idling.png": 65434,
	"./ada_orange_idling.png": 19926,
	"./ada_red_idling.png": 42141,
	"./ada_white_idling.png": 30062,
	"./ada_yellow_idling.png": 92162,
	"./default.png": 94923,
	"./douglas_black_idling.png": 83939,
	"./douglas_blue_idling.png": 60568,
	"./douglas_orange_idling.png": 50302,
	"./douglas_red_idling.png": 2402,
	"./douglas_white_idling.png": 56850,
	"./douglas_yellow_idling.png": 67330,
	"./katniss_black_idling.png": 2112,
	"./katniss_blue_idling.png": 92126,
	"./katniss_orange_idling.png": 94222,
	"./katniss_red_idling.png": 65459,
	"./katniss_white_idling.png": 93290,
	"./katniss_yellow_idling.png": 44873,
	"./rust_black_idling.png": 33434,
	"./rust_blue_idling.png": 50066,
	"./rust_orange_idling.png": 64916,
	"./rust_red_idling.png": 64240,
	"./rust_white_idling.png": 85668,
	"./rust_yellow_idling.png": 82035,
	"./skilly_black_idling.png": 65073,
	"./skilly_blue_idling.png": 19713,
	"./skilly_orange_idling.png": 78478,
	"./skilly_red_idling.png": 41635,
	"./skilly_white_idling.png": 73130,
	"./skilly_yellow_idling.png": 1102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63275;